export const AllFileExtensions = {
    'CSV': 'csv',
    'DJV': 'djv',
    'DJVU': 'djvu',
    'DOC': 'doc',
    'DOCM': 'docm',
    'DOCX': 'docx',
    'DVI': 'dvi',
    'EPS': 'eps',
    'FB2': 'fb2',
    'FODG': 'fodg',
    'FODP': 'fodp',
    'FODS': 'fods',
    'FODT': 'fodt',
    'HTM': 'htm',
    'HTML': 'html',
    'IPYNB': 'ipynb',
    'KEY': 'key',
    'MSG': 'msg',
    'ODF': 'odf',
    'ODG': 'odg',
    'ODM': 'odm',
    'ODP': 'odp',
    'ODS': 'ods',
    'ODT': 'odt',
    'OXPS': 'oxps',
    'PDF': 'pdf',
    'PPS': 'pps',
    'PPSX': 'ppsx',
    'PPT': 'ppt',
    'PPTM': 'pptm',
    'PPTX': 'pptx',
    'PS': 'ps',
    'PUB': 'pub',
    'RMP': 'rmp',
    'RTF': 'rtf',
    'SRT': 'srt',
    'TEX': 'tex',
    'TXT': 'txt',
    'VDX': 'vdx',
    'VSX': 'vsx',
    'VTT': 'vtt',
    'VTX': 'vtx',
    'XLS': 'xls',
    'XLSM': 'xlsm',
    'XLSX': 'xlsx',
    'XML': 'xml',
    'XPS': 'xps',
    'XSN': 'xsn',

    '7Z': '7z',
    'ACE': 'ace',
    'BZ2': 'bz2',
    'CRX': 'crx',
    'GZ': 'gz',
    'GZIP': 'gzip',
    'RAR': 'rar',
    'TAR': 'tar',
    'TGZ': 'tgz',
    'ZIP': 'zip',
    'ZIPX': 'zipx',

    'AI': 'ai',
    'BMP': 'bmp',
    'CDR': 'cdr',
    'CVS': 'cvs',
    'EMF': 'emf',
    'GIF': 'gif',
    'JPEG': 'jpeg',
    'JPG': 'jpg',
    'MAC': 'mac',
    'PCX': 'pcx',
    'PNG': 'png',
    'PSD': 'psd',
    'SVG': 'svg',
    'TGA': 'tga',
    'TIF': 'tif',
    'TIFF': 'tiff',
    'XCF': 'xcf',
    'XLR': 'xlr',

    '3GA': '3ga',
    'AAC': 'aac',
    'AIF': 'aif',
    'AIFC': 'aifc',
    'AIFF': 'aiff',
    'AMR': 'amr',
    'APE': 'ape',
    'ASX': 'asx',
    'FLAC': 'flac',
    'M4A': 'm4a',
    'M4P': 'm4p',
    'MID': 'mid',
    'MIDI': 'midi',
    'MP2': 'mp2',
    'MP3': 'mp3',
    'MPA': 'mpa',
    'OGG': 'ogg',
    'WAV': 'wav',
    'WMA': 'wma',

    '3G2': '3g2',
    '3GP': '3gp',
    '3GPP': '3gpp',
    'ASF': 'asf',
    'AVI': 'avi',
    'DIVX': 'divx',
    'FLV': 'flv',
    'H264': 'h264',
    'M2TS': 'm2ts',
    'M4V': 'm4v',
    'MKV': 'mkv',
    'MOV': 'mov',
    'MP4': 'mp4',
    'MPEG': 'mpeg',
    'MPG': 'mpg',
    'MTS': 'mts',
    'MXF': 'mxf',
    'OGV': 'ogv',
    'QT': 'qt',
    'RM': 'rm',
    'SWF': 'swf',
    'VOB': 'vob',
    'WEBM': 'webm',
    'WMV': 'wmv',
};

export const ARCHIVE_EXTENSIONS = [
    AllFileExtensions['7Z'],
    AllFileExtensions.ACE,
    AllFileExtensions.BZ2,
    AllFileExtensions.CRX,
    AllFileExtensions.GZ,
    AllFileExtensions.GZIP,
    AllFileExtensions.RAR,
    AllFileExtensions.TAR,
    AllFileExtensions.TGZ,
    AllFileExtensions.ZIP,
    AllFileExtensions.ZIPX,
];

export const AUDIO_EXTENSIONS = [
    AllFileExtensions['3GA'],
    AllFileExtensions.AAC,
    AllFileExtensions.AIF,
    AllFileExtensions.AIFC,
    AllFileExtensions.AIFF,
    AllFileExtensions.AMR,
    AllFileExtensions.APE,
    AllFileExtensions.ASX,
    AllFileExtensions.FLAC,
    AllFileExtensions.M4A,
    AllFileExtensions.M4P,
    AllFileExtensions.MID,
    AllFileExtensions.MIDI,
    AllFileExtensions.MP2,
    AllFileExtensions.MP3,
    AllFileExtensions.MPA,
    AllFileExtensions.OGG,
    AllFileExtensions.WAV,
    AllFileExtensions.WMA,
];

export const DOCUMENT_EXTENSIONS = [
    AllFileExtensions.CSV,
    AllFileExtensions.DJV,
    AllFileExtensions.DJVU,
    AllFileExtensions.DOC,
    AllFileExtensions.DOCM,
    AllFileExtensions.DOCX,
    AllFileExtensions.DVI,
    AllFileExtensions.EPS,
    AllFileExtensions.FB2,
    AllFileExtensions.FODG,
    AllFileExtensions.FODP,
    AllFileExtensions.FODS,
    AllFileExtensions.FODT,
    AllFileExtensions.HTM,
    AllFileExtensions.HTML,
    AllFileExtensions.IPYNB,
    AllFileExtensions.KEY,
    AllFileExtensions.MSG,
    AllFileExtensions.ODF,
    AllFileExtensions.ODG,
    AllFileExtensions.ODM,
    AllFileExtensions.ODP,
    AllFileExtensions.ODS,
    AllFileExtensions.ODT,
    AllFileExtensions.OXPS,
    AllFileExtensions.PDF,
    AllFileExtensions.PPS,
    AllFileExtensions.PPSX,
    AllFileExtensions.PPT,
    AllFileExtensions.PPTM,
    AllFileExtensions.PPTX,
    AllFileExtensions.PS,
    AllFileExtensions.PUB,
    AllFileExtensions.RMP,
    AllFileExtensions.RTF,
    AllFileExtensions.SRT,
    AllFileExtensions.TEX,
    AllFileExtensions.TXT,
    AllFileExtensions.VDX,
    AllFileExtensions.VSX,
    AllFileExtensions.VTT,
    AllFileExtensions.VTX,
    AllFileExtensions.XLS,
    AllFileExtensions.XLSM,
    AllFileExtensions.XLSX,
    AllFileExtensions.XML,
    AllFileExtensions.XPS,
    AllFileExtensions.XSN,
];

export const PICTURE_EXTENSIONS = [
    AllFileExtensions.AI,
    AllFileExtensions.BMP,
    AllFileExtensions.CDR,
    AllFileExtensions.CVS,
    AllFileExtensions.EMF,
    AllFileExtensions.GIF,
    AllFileExtensions.JPEG,
    AllFileExtensions.JPG,
    AllFileExtensions.MAC,
    AllFileExtensions.PCX,
    AllFileExtensions.PNG,
    AllFileExtensions.PSD,
    AllFileExtensions.SVG,
    AllFileExtensions.TGA,
    AllFileExtensions.TIF,
    AllFileExtensions.TIFF,
    AllFileExtensions.XCF,
    AllFileExtensions.XLR,
];

export const VIDEO_EXTENSIONS = [
    AllFileExtensions['3G2'],
    AllFileExtensions['3GP'],
    AllFileExtensions['3GPP'],
    AllFileExtensions.ASF,
    AllFileExtensions.AVI,
    AllFileExtensions.DIVX,
    AllFileExtensions.FLV,
    AllFileExtensions.H264,
    AllFileExtensions.M2TS,
    AllFileExtensions.M4V,
    AllFileExtensions.MKV,
    AllFileExtensions.MOV,
    AllFileExtensions.MP4,
    AllFileExtensions.MPEG,
    AllFileExtensions.MPG,
    AllFileExtensions.MTS,
    AllFileExtensions.MXF,
    AllFileExtensions.OGV,
    AllFileExtensions.QT,
    AllFileExtensions.RM,
    AllFileExtensions.SWF,
    AllFileExtensions.VOB,
    AllFileExtensions.WEBM,
    AllFileExtensions.WMV,
];

export const APP_FILE_EXTENSIONS = [
    ...ARCHIVE_EXTENSIONS,
    ...AUDIO_EXTENSIONS,
    ...DOCUMENT_EXTENSIONS,
    ...PICTURE_EXTENSIONS,
    ...VIDEO_EXTENSIONS,
];

export const getFileFromPath = path => {
    const pathType = typeof path;

    if (pathType !== 'string') {
        console.warn(`Path must be a string. You provide "${path}" with type "${pathType}"`);

        return;
    }

    // extract file name from full path (supports `\\` and `/` separators)
    return path.split(/[\\/]/).pop() ?? '';
};

export const getFileName = path => {
    const file = getFileFromPath(path).trim();
    const pos = file.lastIndexOf('.'); // get last position of `.`

    // if file name is empty
    if (!file) return '';
    else if (file.startsWith('.') || pos < 1) return file;

    return file.slice(0, pos);
};

export const getFileExtension = path => {
    const file = getFileFromPath(path).trim();
    const pos = file.lastIndexOf('.'); // get last position of `.`

    // if file name is empty or `.` not found (-1) or comes first (0)
    if (!file || file.startsWith('.') || pos < 1) return '';

    return file.slice(pos + 1);
};
